import React from 'react';
//{ 'https://v1.trackmydown.com/'+ rptLink+".pdf" }

function SpecificContent(props){    
  const { cdnLink, t } = props;
  let rptLink = cdnLink;
  
  return (
    <>
      <p>{t("content.p1")}</p>
      <p>{t("content.p2")}</p>
      <br /><br />
      <a href={ '//cdn.trackmydown.com/'+ rptLink+".pdf" } target="_blank" rel="noopener noreferrer">{t("content.report_link")}</a>
      <br /><br />
    </>
  );
}

const DownContent = (props) => {   
  const { t, changeWord, brand, lf, q, dc, bf, df, r, ff, wf, report, cdnLink } = props;
  
  const cleanTitle = t("content.label");
  const cleanDownCluster = t("content.types.dc");
  const cleanLandFowl = t("content.types.lf");
  const cleanDownFiber = t("content.types.df");
  const cleanBrokenFeathers = t("content.types.bf");
  const cleanFeatherFiber = t("content.types.ff");
  const cleanQuill = t("content.types.q");
  const cleanWaterFowl = t("content.types.wf");
  const cleanResidue = t("content.types.r");
  
  //lotException 
  let lfHide = false;
  let qHide = false;
    
  if(brand == "0404"){
	lf == '0.0' ? lfHide = true : lfHide = false
    q  == '0.0' ? qHide = true  : qHide = false
  }
  
  return (<div className="content-ac co hide">
  <input
    className="ac-input top"
    id="ac-5afd"
    name="ac-5afd"
    data-id="2400"
    data-slug="CONTENT"
    type="checkbox"
    onChange={ () => changeWord('content clicked') }
  />
  <label className="ac-label" htmlFor="ac-5afd">{ cleanTitle }</label>
  <article className="ac-text ac-5afd"><div className="single-post-interior" tabIndex="0">
    <table 
      data-lfhide = { lfHide }
      data-qhide = { qHide}
    >
    <tbody>
    <tr>
    <td>{ cleanDownCluster } : { dc }%</td>
    <td>{ cleanBrokenFeathers } : { bf }%</td>        
    </tr>
    <tr>
    <td>{ cleanDownFiber } : { df }%</td>
    <td>{ cleanResidue } : { r }%</td>
    </tr>
	<tr>
    <td>{ cleanFeatherFiber } : { ff }%</td>
    { !lfHide ? <td>{ cleanLandFowl } : { lf }%</td> : <td></td> }    
    </tr>
    <tr>
    <td>{ cleanWaterFowl } : { wf }%</td>
    { !qHide ? <td>{ cleanQuill } : { q }%</td> : <td></td> }
    </tr>
    </tbody>
    </table>
    <br />
    <SpecificContent
      report 	 = { report }
      cdnLink 	 = { cdnLink }
      t = {t}
	/>		     
    </div></article>
  </div>
);
}

export default DownContent;